import { TenantName } from '@shared/models/tenant-name';

export interface ApplicationKey {
    application_id?: string;
    tenant_list?: TenantName;
    application_key?: string;
    enabled?: boolean;
}
